

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { headerStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader";
import { css } from "styled-components";

headerStyles.titleWrapper = mergeToNew(headerStyles.titleWrapper, {
    width: [9, 9, 8, 9, 9],
});

headerStyles.buttonSet = mergeToNew(headerStyles.buttonSet, {
    width: [3, 3, 4, 3, 3],
});